import { useCustomerMetadataQuery } from "@services/customer/queries";

/**
 * If customer has to fill in required data, initial queries should be disabled
 */
export const useInitialQueriesEnabled = () => {
  const { data: customerMetadata } = useCustomerMetadataQuery();

  // We don't fetch if metadata is not fetched and we don't fetch if customer requires:
  // - password change
  // - contact data update
  // - terms of service acceptance
  if (
    !customerMetadata ||
    (customerMetadata &&
      (customerMetadata.requiresPasswordChange ||
        customerMetadata.requiresContactDataUpdate ||
        !customerMetadata.termsOfServiceAccepted))
  ) {
    return false;
  } else {
    return true;
  }
};
